module.exports = __webpack_public_path__ + "static/media/helengeli-1.d91dc7fe.jpg";